/*
SaiKrishna 10/06/2022 3075154998 Removed unnecessary console.log statements
Suresh Peddavoora 10/28/2022 3075154998  Added Class Name for Text Fields and Buttons
Lalitha  11/9/2022  3075154998 Rename Button Cancel to Reset
*/
import React, {useContext} from 'react';
import {Formik} from 'formik';
import {Button, FormHelperText, Grid, TextField} from '@material-ui/core';
import {ThemeContext} from '../../../../../themes/ThemeProvider';

import ErrorBoundaryForComponents from '../../../../../util/ErrorBoundaryForComponents';
import * as Yup from 'yup';
import GuiAutoComplete from '../../../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../../../components/FormComponents/GuiTextField';

const TaskForm = ({
  setOpen,
  formData,
  setFormData,
  rowData,
  isEditMode,
  oldRuleCode,
  setIsEditMode,
  tableData,
  setTableData,
}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();

  const statuses = [
    {key: 'PDF', value: 'PDF'},
    {key: 'Excel', value: 'Excel'},
  ];
  const initialValues = {
    recordFormat: '',
    srt: '',
    length: '',
    textValue: '',
  };


  const schema = Yup.object().shape({});

  const handleSubmit = (data) => {
    const copiedData = [...tableData];

    copiedData.push(data);
    setTableData(copiedData);
    setOpen(false);

    // else {
    //   const updatedActionData = copiedData.map((item, i) => {
    //     if (i === actionCode) {
    //       return {
    //         ...item,
    //         operator: data?.operator,
    //         fieldOne: data?.fieldOne,
    //         fieldCode: "",
    //         sourceField: data?.sourceField,
    //         fieldFormat: data?.fieldFormat,
    //         type: data?.type,
    //         recordFormat: data?.recordFormat,
    //         actionParamOne: data?.actionParamOne,
    //         actionName: data?.actionName,
    //         description: data?.description,
    //         returnType: data?.returnType,
    //         sequenceNo: i + 1,
    //         disposition: data?.disposition,
    //       };
    //     } else {
    //       return { ...item };
    //     }
    //   });
    //   setTableData(updatedActionData);
    //  // setActionOpen(false);
    //   setIsEditMode(false);
    // }
  };
  return (
    <div className={classes.addRule}>
      <div className={classes.dialoguecardStyles}>
        <Formik
          onSubmit={(values) => handleSubmit(values)}
          initialValues={initialValues}
          validationSchema={schema}
          enableReinitialize
        >
          {(props) => {
            const {
              values,
              handleChange,
              handleSubmit,
              setFieldValue,
              handleReset,
              handleBlur,
              touched,
              errors,
            } = props;
            return (
              <div>
                <form autoComplete="off" noValidate onSubmit={handleSubmit} onReset={handleReset}>
                  <div className="global-field-textfields">
                    <ErrorBoundaryForComponents>
                      <Grid container spacing={2}>
                        <Grid item xs={6} className="form-group">
                          <GuiAutoComplete
                            classes={{
                              option: classes.option,
                            }}
                            {...props}
                            id="recordFormat"
                            options={statuses}
                            size="small"
                            autoHighlight
                            getOptionDisabled={(option) => option.valueCode === null}
                            getOptionLabel={(option) => {
                              return option?.value ? option.value : '';
                            }}
                            onChange={(e, value) => {
                              handleChange(e);
                              setFieldValue('recordFormat', value);
                            }}
                            renderInput={(params) => (
                              <GuiTextField
                                margin="dense"
                                {...params}
                                className={` ${classes.labelName} ${classes.selectLabel}`}
                                variant="outlined"
                                fullWidth
                                label="Record Format"
                                name="recordFormat"
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                placeholder="Select Record Format"
                                inputProps={{
                                  ...params.inputProps,
                                  autoComplete: 'off',
                                }}
                              />
                            )}
                          />
                        </Grid>
                        <Grid item xs={6} className="form-group">
                          <TextField
                            className={` ${classes.labelName} ${classes.inputLabel}`}
                            margin="dense"
                            variant="outlined"
                            placeholder={`Enter Srt`}
                            label="Srt"
                            InputLabelProps={{
                              shrink: true,
                            }}
                            name="srt"
                            value={values.srt}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            fullWidth
                            touched={touched.srt}
                            error={Boolean(touched.srt && errors.srt)}
                          />
                          <FormHelperText style={{color: 'red'}}>
                            {touched.srt && errors.srt}
                          </FormHelperText>
                        </Grid>
                        <Grid item xs={6} className="form-group">
                          <TextField
                            className={` ${classes.labelName} ${classes.inputLabel}`}
                            margin="dense"
                            variant="outlined"
                            type="number"
                            placeholder={`Enter Length`}
                            label="Length"
                            InputLabelProps={{
                              shrink: true,
                            }}
                            name="length"
                            value={values.length}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            fullWidth
                            touched={touched.length}
                            error={Boolean(touched.length && errors.length)}
                          />
                          <FormHelperText style={{color: 'red'}}>
                            {touched.length && errors.length}
                          </FormHelperText>
                        </Grid>
                        <Grid item xs={6} className="form-group">
                          <TextField
                            className={` ${classes.labelName} ${classes.inputLabel}`}
                            margin="dense"
                            variant="outlined"
                            placeholder={`Enter Text Value`}
                            label="Text Value"
                            disabled={values?.textValue}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            name="textValue"
                            value={values.textValue}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            fullWidth
                            touched={touched.textValue}
                            error={Boolean(touched.textValue && errors.textValue)}
                          />
                          <FormHelperText style={{color: 'red'}}>
                            {touched.textValue && errors.textValue}
                          </FormHelperText>
                        </Grid>
                      </Grid>
                    </ErrorBoundaryForComponents>
                  </div>
                  <div className="button-spacing-mb">
                    <Button
                      variant="outlined"
                      onClick={handleReset}
                      className={`reset-btn mx-1 ${classes.buttonRoot}`}
                    >
                      Reset
                    </Button>
                    <Button
                      variant="outlined"
                      type="submit"
                      className={`search-btn mx-1 ${classes.buttonRoot}`}
                    >
                      {isEditMode ? 'Update' : 'Add'}
                    </Button>
                  </div>
                </form>
              </div>
            );
          }}
        </Formik>
      </div>
    </div>
  );
};

export default TaskForm;
